// Add your custom JS here.
jQuery(function($){
  
    var searchTabName = document.location.search;
    var TabName = searchTabName.replace('?nav-item=', '#' );
  
    if (TabName) {
    $('.nav-tabs a[href=' + TabName + ']').tab('show');
      }
  
  });
  
  